import { generateTimeZoneAwareDate } from "./../../../../../utils/timeUtils";

import {
  FORMAT_DATE_NUMBERS,
  FORMAT_TIME_HOUR_MIN,
  addOneHourToStringTime,
} from "../../../../../utils/timeUtils";

export const getSupervisorCommentDataTimeData = (
  timeRange,
  timeZoneLocaleString,
  shouldUseCustomTimeZone,
  formatZoned
) => {
  const supervisorCommentDate = formatZoned(
    generateTimeZoneAwareDate(
      shouldUseCustomTimeZone,
      Number((timeRange && timeRange.ge) || Date.now()),
      timeZoneLocaleString
    ),
    FORMAT_DATE_NUMBERS
  );

  // start and end time is a range of one hour
  // supervisor context is applied by hour only
  const supervisorCommentStartTime = formatZoned(
    generateTimeZoneAwareDate(
      shouldUseCustomTimeZone,
      Number((timeRange && timeRange.ge) || Date.now()),
      timeZoneLocaleString
    ),
    FORMAT_TIME_HOUR_MIN
  );

  const supervisorCommentEndTime = formatZoned(
    generateTimeZoneAwareDate(
      shouldUseCustomTimeZone,
      Number(addOneHourToStringTime(timeRange && timeRange.ge) || Date.now()),
      timeZoneLocaleString
    ),
    FORMAT_TIME_HOUR_MIN
  );

  return {
    date: supervisorCommentDate,
    startTime: supervisorCommentStartTime,
    endTime: supervisorCommentEndTime,
  };
};
